import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loadable from '@/components/common/loadable';
import Loading from '@/components/common/loading';
import { getTag } from '@/store/actions/tag';

const TagInfo = Loadable({
  loader: () => import('@/components/tag/detail'),
});

export default function TagInformation({ match: { params } }) {
  const dispatch = useDispatch();
  const isLoading = useSelector(({ tag }) => tag.isLoading);

  useEffect(() => {
    dispatch(getTag({ ...params }));
  }, []);

  if (isLoading) return <Loading isLoading />;
  return <TagInfo />;
}
